class EofyBottomTier extends HTMLElement {
  static MESSAGE_LEVELS = [0, 200, 300, 400, 500];

  static DEFAULT_TITLES = {
    0: '[total] in your cart',
    200: '[total] in your cart',
    300: 'You unlocked an extra $30 off!',
    400: 'You unlocked an extra $50 off!',
    500: 'Congratulations!',
  };

  static DEFAULT_SUBTITLES = {
    0: 'Spend [amount] to unlock an extra $30 off',
    200: 'Spend [amount] to unlock an extra $30 off',
    300: 'Spend [amount] to unlock an extra $50 off',
    400: 'Spend [amount] to unlock an extra $60 off',
    500: 'You unlocked an extra $60 off!',
  };

  connectedCallback() {
    if (this.dataset.eofyBottomTierInit === 'true') return;
    this.dataset.eofyBottomTierInit = 'true';

    this.ringImages = Array.from(this.querySelectorAll('.eofy-bottom-tier__ring-img'));
    this.titleEl = this.querySelector('.eofy-bottom-tier__title');
    this.messageEl = this.querySelector('.eofy-bottom-tier__subtitle');
    this.checkoutBtn = this.querySelector('[data-eofy-bottom-tier-checkout]');
    this.messageTitles = this.loadMessageTemplates('title');
    this.messageSubtitles = this.loadMessageTemplates('subtitle');
    this.ringCols = Array.from(this.querySelectorAll('.eofy-bottom-tier__ring-col'));
    this.moneyFormat =
      (window.theme && window.theme.strings && window.theme.strings.moneyFormat) || '${{amount}}';
    this.moneyFormatNoDecimals = this.moneyFormat.replace(
      /\{\{\s*amount(?:_[\w_]+)?\s*\}\}/,
      '{{ amount_no_decimals }}'
    );
    this.tiers = this.parseTiers();
    this.eligibleHandles = this.parseEligibleHandles();
    this.hideWhenEmpty = this.dataset.hideWhenEmpty === 'true';

    this.bindEvents();
    this.refresh();
  }

  disconnectedCallback() {
    if (this.onCartLoadJq && window.jQuery) {
      window.jQuery(document.body).off('ajaxCart.afterCartLoad', this.onCartLoadJq);
    }
  }

  loadMessageTemplates(type) {
    const defaults = type === 'title' ? EofyBottomTier.DEFAULT_TITLES : EofyBottomTier.DEFAULT_SUBTITLES;
    const templates = {};

    EofyBottomTier.MESSAGE_LEVELS.forEach((level) => {
      const template = this.querySelector(`template[data-eofy-bottom-tier-${type}="${level}"]`);
      templates[level] = template && template.innerHTML
        ? template.innerHTML
        : defaults[level];
    });

    return templates;
  }

  parseTiers() {
    try {
      const parsed = JSON.parse(this.dataset.tiers || '[]');
      if (!Array.isArray(parsed) || !parsed.length) return this.defaultTiers();
      return parsed
        .map((tier) => ({
          spendCents: Number(tier.spendCents) || 0,
          reward: Number(tier.reward) || 0,
        }))
        .filter((tier) => tier.spendCents > 0)
        .sort((a, b) => a.spendCents - b.spendCents);
    } catch (error) {
      return this.defaultTiers();
    }
  }

  parseEligibleHandles() {
    const raw = this.dataset.eligibleHandles || '';
    return raw
      .split(',')
      .map((handle) => handle.trim().toLowerCase())
      .filter(Boolean);
  }

  getEligibleTotal(cart) {
    if (!cart) return 0;

    if (!this.eligibleHandles.length) {
      return Math.max(0, Number(cart.total_price.toFixed(0)) || 0);
    }

    return (cart.items || []).reduce((sum, item) => {
      const handle = String(item.handle || '').toLowerCase();
      if (!this.eligibleHandles.includes(handle)) return sum;

      return sum + (Number(item.final_line_price) || Number(item.line_price) || 0);
    }, 0);
  }

  defaultTiers() {
    return [
      { spendCents: 30000, reward: 30 },
      { spendCents: 40000, reward: 50 },
      { spendCents: 50000, reward: 60 },
    ];
  }

  getRingState(totalCents) {
    const safeTotal = Math.max(0, Number(totalCents) || 0);
    const tier1Cents = this.tiers[0]?.spendCents || 30000;
    const tier2Cents = this.tiers[1]?.spendCents || 40000;
    const tier3Cents = this.tiers[2]?.spendCents || 50000;

    if (safeTotal >= tier3Cents) return 500;
    if (safeTotal >= tier2Cents) return 400;
    if (safeTotal >= tier1Cents) return 300;
    if (safeTotal > 0) return 200;

    return 0;
  }

  getRemainingCents(ringState, totalCents) {
    const safeTotal = Math.max(0, Number(totalCents) || 0);

    if (ringState >= 500) return 0;
    if (ringState >= 400) return Math.max(0, (this.tiers[2]?.spendCents || 50000) - safeTotal);
    if (ringState >= 300) return Math.max(0, (this.tiers[1]?.spendCents || 40000) - safeTotal);

    return Math.max(0, (this.tiers[0]?.spendCents || 30000) - safeTotal);
  }

  bindEvents() {
    this.onCartLoadJq = (_evt, cart) => {
      if (cart) {
        this.updateFromCart(cart);
        return;
      }
      this.refresh();
    };

    if (window.jQuery) {
      window.jQuery(document.body).on('ajaxCart.afterCartLoad', this.onCartLoadJq);
    }

    document.addEventListener('cart:refresh', () => this.refresh());
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') this.refresh();
    });
    this.ringCols.forEach((ringCol) => {
      ringCol.addEventListener('click', () => {
        // $(".site-nav__link").click();
        ajaxCart.load();
      });
    });
    this.checkoutBtn.addEventListener('click', () => {
      window.dataLayer.push({ "event_parameters": null });
      window.dataLayer.push({
        "event": "ga4Event",
        "event_name": "checkout_button",
        "event_parameters": {
          "module": "EOFY Bottom Bar",
          "button_name": "Checkout"
        }
      });
    });
  }

  refresh() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((cart) => this.updateFromCart(cart))
      .catch(() => { });
  }

  updateFromCart(cart) {
    this.update(this.getEligibleTotal(cart));
  }

  update(totalCents) {
    const safeTotal = Math.max(0, Number(totalCents) || 0);
    const hasItems = safeTotal > 0;

    if (this.hideWhenEmpty && !hasItems) {
      this.classList.add('is-hidden');
      return;
    }

    this.classList.remove('is-hidden');
    this.updateRingImage(safeTotal);
    this.updateCopy(safeTotal);
    this.updateCheckout(safeTotal);
  }

  updateCopy(totalCents) {
    const ringState = this.getRingState(totalCents);
    const titleTemplate = this.messageTitles[ringState] || this.messageTitles[0];
    const subtitleTemplate = this.messageSubtitles[ringState] || this.messageSubtitles[0];
    const total = this.formatMoney(totalCents);
    const remaining = this.getRemainingCents(ringState, totalCents);
    const amount = this.formatMoney(remaining);

    if (this.titleEl) {
      this.titleEl.innerHTML = this.applyPlaceholders(titleTemplate, {
        total,
        amount,
      });
    }

    if (this.messageEl) {
      this.messageEl.innerHTML = this.applyPlaceholders(subtitleTemplate, {
        total,
        amount,
      });
    }
  }

  updateRingImage(totalCents) {
    if (!this.ringImages.length) return;

    const activeState = this.getRingState(totalCents);
    let matched = false;

    this.ringImages.forEach((image) => {
      const imageState = Number(image.dataset.progress) || 0;
      const isActive = imageState === activeState;
      image.classList.toggle('is-active', isActive);
      if (isActive) matched = true;
    });

    if (!matched) {
      const fallback =
        this.ringImages.find((image) => Number(image.dataset.progress) === 0) || this.ringImages[0];
      if (fallback) fallback.classList.add('is-active');
    }
  }

  applyPlaceholders(template, values) {
    return template
      .replace(/\[total\]/g, values.total || '')
      .replace(/\[amount\]/g, values.amount || '')
      .replace(/\$XXX/gi, values.total || '')
      .replace(/\$\*\*\*/g, values.amount || '')
      .replace(/\{\{\s*total\s*\}\}/g, values.total || '')
      .replace(/\{\{\s*amount\s*\}\}/g, values.amount || '');
  }

  updateCheckout(totalCents) {
    if (!this.checkoutBtn) return;

    const minCheckoutCents = Number(this.dataset.minCheckoutCents) || this.tiers[0].spendCents;
    const canCheckout = totalCents >= minCheckoutCents;
    this.checkoutBtn.classList.toggle('is-disabled', !canCheckout);
    this.checkoutBtn.setAttribute('aria-disabled', canCheckout ? 'false' : 'true');
  }

  formatMoney(cents) {
    const safeCents = Math.max(0, Number(cents) || 0);

    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(safeCents, this.moneyFormatNoDecimals);
    }

    const amount = (Number(cents) / 100).toFixed(0);

    return `$${amount}`;
  }
}

if (!customElements.get('eofy-bottom-tier')) {
  customElements.define('eofy-bottom-tier', EofyBottomTier);
}
